import type { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  helperTextContainer: {
    alignContent: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',

    '&.error-label': {
      alignItems: 'center',
      justifyContent: 'left',
      color: theme.new.color.errorPrimary,
    },

    '.characterCount': {
      marginLeft: '8px',
    },
  },

  errorIconContainer: {
    marginRight: '4px',
    height: '16px',
  },
}));

export default useStyles;
